import { SBaseDisplay } from '@summit/core';
import { EboNameObject } from '../../base-classes/ebo-name-object';
import { Company } from '../company/company';

export class ServiceArea extends EboNameObject implements SBaseDisplay {
  tenantID: string;

  companyId: string;
  company: Company;

  constructor(jsonData?: Partial<ServiceArea>) {
    super(jsonData);
    if (jsonData) {
      if (jsonData.company) this.company = new Company(jsonData.company);
    }
  }

  toShortString(): string {
    return `CSA ${this.name}`;
  }
}
